import { getSessionUUID } from '../components/lib/AuthToken'; // Import the utility function
import logger from "../utils/logger";


export const fetch_all_lanes = async () => {
    
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
        };

        // Send Request to backend
        const response = await fetch('/warehouse/get_lanes', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error fetching warehouse data:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const fetch_all_warehouse_costs = async () => {
    
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
        };

        // Send Request to backend
        const response = await fetch('/warehouse/get_costs', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error fetching warehouse data:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const edit_lane = async (lane_data) => {
    logger.log("Editing lane with data:", lane_data); // Debugging log
    try {
        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ lane_data })
        };

        // Send Request to backend
        const response = await fetch('/warehouse/edit_lane', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error editing lane:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const stock_log = async (stockData) => {
    // insert into stock log table

    try{
        logger.log("Logging stock to database: ", stockData);
        const sessionToken = await getSessionUUID();
        // User input
        const body = {
            stock_data: stockData
        };

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/warehouse/stock_log', requestOptions);
        const responseBody = await response.json();

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { message: responseBody.message || 'Stock logged to database', status: response.status };
        } else {
            // Show error message with server response
            return { message: responseBody.error || 'Failed to log stock', status: response.status };
        }
    } catch (err) {
        logger.error("Error updating stock log:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

//-------------------------------------------------------------------------------------------------

export const add_warehouse_costs = async (costData) => {
    // insert into stock log table

    try{
        const sessionToken = await getSessionUUID();
        // User input
        const body = {
            cost_data: costData
        };

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/warehouse/add_costs', requestOptions);
        const responseBody = await response.json();

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { message: responseBody.message || 'costs added to database', status: response.status };
        } else {
            // Show error message with server response
            return { message: responseBody.error || 'Failed to add costs', status: response.status };
        }
    } catch (err) {
        logger.error("Error updating warehouse costs:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

//-------------------------------------------------------------------------------------------------

export const edit_warehouse_costs = async (cost_data) => {
    try {
        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ cost_data })
        };

        // Send Request to backend
        const response = await fetch('/warehouse/edit_costs', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error editing lane:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const delete_warehouse_costs = async (customerId) => {
    
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ customerId })
        };

        // Send Request to backend
        const response = await fetch('/warehouse/delete_costs', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error deleting costs: ", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const download_warehouse_charges = async (date) => {
    try {

        const sessionToken = await getSessionUUID();
        const body = JSON.stringify({ date });

        const response = await fetch('/warehouse/download_warehouse_charges', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body,
        });

        if (!response.ok) {
            throw new Error(`Failed to download warehouse charges: ${response.status} ${response.statusText}`);
        }

        const contentType = response.headers.get("Content-Type");
        if (!contentType || !contentType.includes("csv")) {
            throw new Error(`Expected a CSV file, but got: ${contentType}`);
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        // Extract filename from headers
        const contentDisposition = response.headers.get("Content-Disposition");
        let filename = `warehouse-${Date.now()}.csv`;

        if (contentDisposition) {
            const match = contentDisposition.match(/filename\*?=["']?([^;"']+)\*?/);
            if (match) {
                filename = decodeURIComponent(match[1]).replace(/["']/g, '');
            }
        }

        // Create and click the link
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();

        // Cleanup
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        return { message: "Warehouse charges downloaded successfully!", status: 200 };

    } catch (err) {
        logger.error("Error downloading warehouse charges:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const invoice_warehouse_charges = async (date, accountCodeId) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/warehouse/invoice_warehouse_charges', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify({ date, account_code_id: accountCodeId }),
        });
        const data = await response.json();
        return { status: response.status, data };
    } catch (err) {
        logger.error("Error generating warehouse invoices:", err);
        return { status: 500, data: { error: err.message || 'Unable to generate warehouse invoices' } };
    }
};

//-------------------------------------------------------------------------------------------------

export const fetch_snapshot_data = async (queryData) => {
    try {
        const sessionToken = await getSessionUUID();

        const queryParams = new URLSearchParams({
            id: queryData.id || '',
        });

        const response = await fetch(`/warehouse/get_snapshot?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
        });

        const responseBody = await response.json();

        return {
            message: responseBody.error || 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error fetching data: ", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

export const downloadDeliveryNote = async (orderData) => {
    // Function to download the delivery note PDF
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch("/warehouse/generate-delivery-note", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${sessionToken}`,
            },
            body: JSON.stringify(orderData),
        });

        if (!response.ok) {
            throw new Error("Failed to download delivery note.");
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `DeliveryNote-${orderData.order_number}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        logger.error("Download error:", error);
    }
};

//-------------------------------------------------------------------------------------------------

export const fetchOrders = async () => {
    
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
        };

        // Send Request to backend
        const response = await fetch('/warehouse/get_orders', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error fetching warehouse data:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const create_order = async (orderData) => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ order_data: orderData })
        };

        const response = await fetch('/warehouse/create_order', requestOptions);
        
        // Check if response is HTML (indicates session expiration/redirect)
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('text/html')) {
            throw new Error('Your session has expired. Please log in again.');
        }
        
        const responseBody = await response.json();

        return {
            message: responseBody.message || 'Order created successfully',
            order_number: responseBody.order_number, // Pass through order_number
            order_id: responseBody.order_id,         // Pass through order_id
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error creating order:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const delete_order = async (orderId) => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            }
        };

        const response = await fetch(`/warehouse/delete_order/${orderId}`, requestOptions);
        const responseBody = await response.json();

        return {
            message: responseBody.message || 'Order deleted successfully',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error deleting order:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const pick_order = async (orderData, user_id = null) => {
    try {
        const sessionToken = await getSessionUUID();

        // Add user_id to the orderData if provided
        const requestData = {
            ...orderData,
            user_id: user_id
        };

        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(requestData)
        };

        const response = await fetch('/warehouse/pick_order', requestOptions);
        const responseBody = await response.json();

        return {
            message: responseBody.message || 'Order picked successfully',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error picking order:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const dispatch_order = async (order_id, warehouseData = [], user_id = null) => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ 
                order_id,
                user_id,  // Pass user_id for logging
                warehouse_data: warehouseData,
            })
        };

        const response = await fetch('/warehouse/dispatch_order', requestOptions);

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Failed to dispatch order');
        }

        const responseData = await response.json();

        return {
            message: responseData.message || 'Order dispatched successfully',
            status: response.status,
        };
    } catch (err) {
        logger.error("Error dispatching order:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const generate_paperwork = async (order_id, order_number, warehouseData = [], user_id = null) => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ 
                order_id,
                warehouse_data: warehouseData,  // Pass warehouse data for PDF generation
                user_id  // Pass user_id for stock logging
            })
        };

        const response = await fetch('/warehouse/generate_paperwork', requestOptions);

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Failed to generate paperwork');
        }

        // Handle PDF download
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        
        // Extract filename from response headers or use default
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = `${order_number}.pdf`;
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="(.+)"/);
            if (filenameMatch) {
                filename = filenameMatch[1];
            }
        }
        
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        return {
            message: 'Delivery paperwork generated and downloaded successfully',
            status: response.status,
        };
    } catch (err) {
        logger.error("Error generating paperwork:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const generate_pick_note = async (order_id) => {
    console.log("Generating pick note for order_id from old warehouse route"); // Debugging log
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ 
                order_id,
            })
        };

        const response = await fetch('/enhanced_warehouse/generate_pick_note', requestOptions);

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Failed to generate pick note');
        }

        // Handle PDF download
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        
        // Extract filename from response headers or use default with order_id
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = `PickNote-Order-${order_id}.pdf`; // Default fallback using order_id
        if (contentDisposition) {
            // Try multiple regex patterns to extract filename
            let filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
            if (!filenameMatch) {
                filenameMatch = contentDisposition.match(/filename=([^;,\s]+)/);
            }
            if (filenameMatch) {
                filename = filenameMatch[1];
            }
        }
        
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        return {
            message: 'Pick note generated and downloaded successfully',
            status: response.status,
        };
    } catch (err) {
        logger.error("Error generating pick note:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const generate_qr_code = async (warehouse_id, qr_data) => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ 
                warehouse_id: warehouse_id,
                qr_data: qr_data
            })
        };

        const response = await fetch('/warehouse/generate-qr', requestOptions);
        const responseBody = await response.json();

        return {
            message: responseBody.message || 'QR code generated successfully',
            status: response.status,
            data: responseBody || null,
            qr_url: responseBody.qr_url || null
        };
    } catch (err) {
        logger.error("Error generating QR code:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const getWarehousePalletReport = async (customerId) => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            }
        };

        const response = await fetch(`/warehouse/pallet-report/${customerId}`, requestOptions);
        const responseBody = await response.json();

        if (response.ok) {
            return {
                success: true,
                message: responseBody.message || 'Pallet report fetched successfully',
                status: response.status,
                data: responseBody.data || null
            };
        } else {
            return {
                success: false,
                message: responseBody.error || responseBody.message || 'Failed to fetch pallet report',
                status: response.status
            };
        }
    } catch (err) {
        logger.error("Error fetching warehouse pallet report:", err);
        return {
            success: false,
            message: err.message || 'An error occurred',
            status: 500
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const getWarehouseProductReport = async (customerId) => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            }
        };

        const response = await fetch(`/enhanced_warehouse/reports/products/${customerId}`, requestOptions);
        const responseBody = await response.json();

        if (response.ok) {
            return {
                success: true,
                message: responseBody.message || 'Product report fetched successfully',
                status: response.status,
                data: responseBody.data || null
            };
        } else {
            return {
                success: false,
                message: responseBody.error || responseBody.message || 'Failed to fetch product report',
                status: response.status
            };
        }
    } catch (err) {
        logger.error("Error fetching warehouse product report:", err);
        return {
            success: false,
            message: err.message || 'An error occurred',
            status: 500
        };
    }
};